import { useCallback, useEffect, useRef } from 'react'
import type { Editor } from '@tiptap/core'
import { DocumentEditor } from '@/components/document-editor'
import type { RecyclabilitySectionEditorRegistration } from './RecyclabilityAssessmentDocumentSectionBlock'

export const RECYCLABILITY_ASSESSMENT_DOCUMENT_COVER_EDITOR_ID = '__cover__'

type RecyclabilityAssessmentDocumentCoverBlockProps = {
  markdown: string
  contentSyncKey: number
  onRegister: (registration: RecyclabilitySectionEditorRegistration) => void
  onUnregister: (sectionId: string) => void
  onSectionFocus: (sectionId: string) => void
  onSectionEditorReady: (sectionId: string) => void
}

export function RecyclabilityAssessmentDocumentCoverBlock({
  markdown,
  contentSyncKey,
  onRegister,
  onUnregister,
  onSectionFocus,
  onSectionEditorReady,
}: RecyclabilityAssessmentDocumentCoverBlockProps) {
  const editorRef = useRef<Editor | null>(null)

  useEffect(() => {
    onRegister({
      sectionId: RECYCLABILITY_ASSESSMENT_DOCUMENT_COVER_EDITOR_ID,
      editorRef,
    })
    return () => {
      onUnregister(RECYCLABILITY_ASSESSMENT_DOCUMENT_COVER_EDITOR_ID)
    }
  }, [onRegister, onUnregister])

  const handleEditorReady = useCallback(
    (_editor: Editor) => {
      onSectionEditorReady(RECYCLABILITY_ASSESSMENT_DOCUMENT_COVER_EDITOR_ID)
    },
    [onSectionEditorReady]
  )

  const handleEditorFocus = useCallback(() => {
    onSectionFocus(RECYCLABILITY_ASSESSMENT_DOCUMENT_COVER_EDITOR_ID)
  }, [onSectionFocus])

  return (
    <section
      id='recyclability-document-cover'
      className='flex scroll-mt-4 flex-col'
    >
      <DocumentEditor
        embedded
        markdown={markdown}
        editorRef={editorRef}
        onEditorReady={handleEditorReady}
        onEditorFocus={handleEditorFocus}
        contentSyncKey={contentSyncKey}
        documentBodyClassName='min-h-[200px] px-4 py-4'
      />
    </section>
  )
}
